import { render, staticRenderFns } from "./EmailConfirmBanner.vue?vue&type=template&id=3d40d9d2&scoped=true&"
import script from "./EmailConfirmBanner.vue?vue&type=script&lang=js&"
export * from "./EmailConfirmBanner.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfirmBanner.vue?vue&type=style&index=0&id=3d40d9d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d40d9d2",
  null
  
)

export default component.exports